import { CurrencyDollarIcon as PhosphorCurrencyDollarIcon } from "@phosphor-icons/react/dist/ssr/CurrencyDollar";

import { createAppIcon } from "@/components/createAppIcon";

export const CurrencyIcon = /* @__PURE__ */ createAppIcon(PhosphorCurrencyDollarIcon);
